<template>
  <div class="clients">
    <div :style="'backgroundImage: url('+clients_bg+')'" class="clients_bg"></div>
    <ClientsHeader/>
    <router-view
      :key="$route.path"
      :clientsData="clientsData"
      @removea-audio-player="removeAudioPlayer"
    />
    <ClientsFooter/>
    <AudioPlayer ref="aplayer" />
  </div>
</template>

<script>
/* eslint-disable no-undef */
import ClientsHeader from './components/ClientsHeader'
import ClientsFooter from './components/ClientsFooter'
import AudioPlayer from '@/components/widget/AudioPlayer'
import bg from '@/assets/images/clients/bg_default.png'
import { getBorrowRecords } from '@/api/toB'
import { getBorrowToken } from '@/utils/get_toB_token'
import { setToken, getToken, removeToken } from '@/utils/auth'
import { mapState, mapActions } from 'vuex'
import '@/utils/audioRequest'

export default {
  name: 'client',
  components: {
    ClientsHeader,
    ClientsFooter,
    AudioPlayer
  },
  computed: {
    ...mapState({
      cid: state => state.toB.cid,
      clientInfo: state => state.toB.clientInfo
    }),
    isMobile: {
      get () {
        return this.$store.state.isMobile
      },
      set (value) {
        this.$store.commit('setIsMobile', value)
      }
    },
    isLoading: {
      get () {
        return this.$store.state.toB.isLoading
      },
      set (value) {
        this.$store.commit('toB/setIsLoading', value)
      }
    },
    isCanBorrow: {
      get () {
        return this.$store.state.toB.isCanBorrow
      },
      set (value) {
        this.$store.commit('toB/setIsCanBorrow', value)
      }
    }
  },
  data () {
    return {
      clients_bg: bg,
      clientsData: '',
      type: 'ip',
      clientId: null,
      clientToken: ''
    }
  },
  created () {
    this.isLoading = true
    this.isMobile = this.ckeckIsMobile()
    this.getCID()

    this.getClientInfo(this.cid)
      .then(
        (res) => {
          this.clientId = res.id
          if (!this.isMobile) {
            this.checkClientToken(this.clientId)
          } else {
            this.isLoading = false
          }
        })
    this.fetchClientData(this.cid)
  },
  mounted () {
    // 阻止ios雙擊放大
    window.onload = function () {
    // 阻止雙擊放大
      var lastTouchEnd = 0
      document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      document.addEventListener('touchend', function (event) {
        var now = (new Date()).getTime()
        if (now - lastTouchEnd <= 300) {
          event.preventDefault()
        }
        lastTouchEnd = now
      }, false)

      // 阻止雙指放大
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault()
      })
    }
  },
  beforeDestroy () {

  },
  methods: {
    ...mapActions('toB', [
      'setCID',
      'getClientInfo',
      'setBorrowRecord',
      'fetchClientData',
      'setClientToken',
      'setBorrowErrorText'
    ]),
    getCID () {
      let cid = window.location.pathname.replace('/org/', '')
      if (cid.indexOf('/') !== -1) {
        cid = cid.split('/')[0]
      }
      this.setCID(cid)
      return cid
    },
    ckeckIsMobile () {
      const u = navigator.userAgent
      // console.log(navigator.userAgent)
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      const isiPad = (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
      return !!((isiPad === true || isiOS === true || isAndroid === true))
    },
    checkClientToken (id) {
      const clientToken = getToken(this.cid)

      if (clientToken === null) {
        this.getClientToken(id, this.cid)
      } else {
        this.setClientToken(clientToken)
        this.fetchBorrowRecords()
      }
    },
    getClientToken (clientId) {
      getBorrowToken(clientId, this.type)
        .then((token) => {
          // console.log(token)
          this.setClientToken(token)
          setToken(token, this.cid)
          this.fetchBorrowRecords()
        })
        .catch((err) => {
          console.log(err)
          this.setBorrowErrorText('您的 IP 位址不在借聽服務範圍')
          this.isCanBorrow = false
          this.isLoading = false
        })
    },
    fetchBorrowRecords () {
      getBorrowRecords()
        .then(res => {
          // console.log(res.data)
          const borrowTime = localStorage.getItem('borrowTime')
          if (res.data.length === 0 && borrowTime !== null) {
            localStorage.removeItem('borrowTime')
          }
          this.setBorrowRecord(res.data)
          this.isCanBorrow = true
          this.isLoading = false
        })
        .catch((err) => {
          console.log(err)
          // console.log(err.response.status)
          if (err.response.status === 422) {
            removeToken(this.cid)
            window.location.reload()
          }
        })
    },
    removeAudioPlayer () {
      // console.log('remove')
      this.$refs.aplayer.deleteMedia()
    }
  }
}
</script>

<style lang="scss"  scoped>
.clients {
  margin-top: 0;
}
.clients_bg {
  z-index: -1;
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 50%;
  min-height: 100%;
  width: 100%;
  max-width: 600px;
  transform: translate(-50%, 0);
}
@media screen and (min-width: 576px) {
  .clients_bg {
    max-width: 900px;
  }
}
@media screen and (min-width: 768px) {
  .clients {
    margin-top: -128px;
  }
  .clients_bg {
    max-width: 1500px;
  }
}
@media screen and (min-width: 1280px) {
  .clients_bg {
    max-width: 1500px;
  }
}
@media screen and (min-width: 1680px) {
  .clients_bg {
    max-width: 1700px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/clients/index.vue